const PHRASES = [
  'Gestão de drones feita para o campo',
  'Mais voos. Menos planilha.',
  'Para quem leva a operação a sério',
  'Do plano de voo ao recebimento, tudo em um app',
  'O app preferido dos operadores de precisão',
  'Controle real. Resultado visível.',
  'Sua operação, no bolso.',
]

export function MarqueeSection() {
  const items = [...PHRASES, ...PHRASES]

  return (
    <div
      aria-hidden
      style={{
        background: '#1A5C2E',
        padding: '13px 0',
        overflow: 'hidden',
      }}
    >
      <div className="marquee-track">
        {items.map((phrase, i) => (
          <span
            key={i}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              fontSize: 11,
              fontWeight: 700,
              color: 'rgba(255,255,255,0.65)',
              letterSpacing: '0.06em',
              textTransform: 'uppercase',
              whiteSpace: 'nowrap',
              padding: '0 28px',
            }}
          >
            <span
              style={{
                display: 'inline-block',
                width: 5,
                height: 5,
                borderRadius: '50%',
                background: '#52C97E',
                marginRight: 20,
                flexShrink: 0,
              }}
            />
            {phrase}
          </span>
        ))}
      </div>
    </div>
  )
}
